<template>
  <a-drawer
    :title="title"
    :width="720"
    :visible="open"
    @cancel="cancel"
    @close="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('社区账单.选择社区')" prop="communityId" v-if="!isCommunityRole">
        <a-select
          v-model="form.communityId"
          :placeholder="$t('通用.输入.请选择')"
          @change="onCommunityChange"
          :disabled="formType === 2"
          show-search
          :filter-option="filterOption"
          allow-clear
        >
          <a-select-option v-for="(item, index) in communityList" :key="index" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('社区账单.选择业主房号')" prop="roomId" v-if="form.communityId || isCommunityRole">
        <a-select
          v-model="form.roomId"
          :placeholder="$t('通用.输入.请选择')"
          :disabled="formType === 2"
          show-search
          :filter-option="filterOption"
          allow-clear
        >
          <a-select-option v-for="(item, index) in allRoomList" :key="index" :value="item.id">
            {{ item.ownerName }} - {{ item.roomNumber }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('社区账单.账单类型')" prop="billType">
        <a-radio-group v-model="form.billType" @change="onBillTypeChange" :disabled="formType === 2">
          <a-radio-button v-for="(item, index) in customDict.CommunityBillTypeEnum" :key="index" :value="item.type">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item :label="$t('社区账单.账单年月')" prop="billMonth">
        <a-month-picker v-model="form.billMonthFormat" format="YYYY-MM" value-format="YYYY-MM" style="width: 100%" />
      </a-form-model-item>

      <!-- 水电燃气房租费表单 -->
      <template v-if="form.billType === 1">
        <a-divider>{{ $t('社区账单.水费') }}</a-divider>
        <a-form-model-item :label="$t('社区账单.水费金额')">
          <a-input-number v-model="form.waterFee" :min="0" :precision="2" style="width: 200px" @change="calculateUtilityFee" />
        </a-form-model-item>
        <a-form-model-item :label="$t('社区账单.水费账单图片')">
          <OssUploadSingle v-model="form.waterImage" type="img" :maxSize="200"></OssUploadSingle>
        </a-form-model-item>

        <a-divider>{{ $t('社区账单.电费') }}</a-divider>
        <a-form-model-item :label="$t('社区账单.电费金额')">
          <a-input-number v-model="form.electricFee" :min="0" :precision="2" style="width: 200px" @change="calculateUtilityFee" />
        </a-form-model-item>
        <a-form-model-item :label="$t('社区账单.电费账单图片')">
          <OssUploadSingle v-model="form.electricImage" type="img" :maxSize="200"></OssUploadSingle>
        </a-form-model-item>

        <a-divider>{{ $t('社区账单.燃气费') }}</a-divider>
        <a-form-model-item :label="$t('社区账单.燃气费金额')">
          <a-input-number v-model="form.gasFee" :min="0" :precision="2" style="width: 200px" @change="calculateUtilityFee" />
        </a-form-model-item>
        <a-form-model-item :label="$t('社区账单.燃气费账单图片')">
          <OssUploadSingle v-model="form.gasImage" type="img" :maxSize="200"></OssUploadSingle>
        </a-form-model-item>

        <a-divider>{{ $t('房租费') }}</a-divider>
        <a-form-model-item :label="$t('房租费金额')">
          <a-input-number v-model="form.rentFee" :min="0" :precision="2" style="width: 200px" @change="calculateUtilityFee" />
        </a-form-model-item>
        <a-form-model-item :label="$t('房租费账单图片')">
          <OssUploadSingle v-model="form.rentImage" type="img" :maxSize="200"></OssUploadSingle>
        </a-form-model-item>

        <a-form-model-item :label="$t('社区账单.账单总金额')" prop="totalFee">
          <a-input-number v-model="form.totalFee" :min="0" :precision="2" style="width: 200px" disabled />
        </a-form-model-item>
      </template>

      <!-- 物业费表单 -->
      <template v-if="form.billType === 2">
        <a-divider>{{ $t('社区账单.物业费') }}</a-divider>
        <a-form-model-item :label="$t('社区账单.物业费每月')">
          <a-input-number v-model="form.propertyFeePerMonth" :min="0" :precision="2" style="width: 200px" @change="calculatePropertyFee" />
        </a-form-model-item>
        <a-form-model-item :label="$t('社区账单.缴纳月数')">
          <a-input-number v-model="form.propertyMonths" :min="1" :max="12" style="width: 200px" @change="calculatePropertyFee" />
        </a-form-model-item>
        <a-form-model-item :label="$t('社区账单.账单总金额')" prop="totalFee">
          <a-input-number v-model="form.totalFee" :min="0" :precision="2" style="width: 200px" disabled />
        </a-form-model-item>
      </template>

      <a-form-model-item :label="$t('社区账单.备注')">
        <a-textarea v-model="form.remark" :rows="3" :maxLength="500" />
      </a-form-model-item>
    </a-form-model>

    <div class="drawer-footer">
      <a-button @click="cancel">{{$t('通用.按钮.取消')}}</a-button>
      <a-button type="primary" @click="submitForm" :loading="submitLoading">{{$t('通用.按钮.保存')}}</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getBill, addBill, updateBill, getUserCommunityList } from '@/api/homeservice/bill'
import { listWorker } from '@/api/homeworker/profile'
import OssUploadSingle from '@/components/OssUploadSingle'
import { mapGetters } from 'vuex'
import auth from '@/plugins/auth'

export default {
  name: 'CreateForm',
  components: { OssUploadSingle },
  data() {
    return {
      title: '',
      open: false,
      submitLoading: false,
      formType: 1,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      communityList: [],
      userCommunityList: [],
      allRoomList: [], // 所有房间列表（拍平后）
      currentCommunityId: null, // 当前用户关联的社区ID
      form: {
        id: null,
        communityId: undefined,
        roomId: undefined,
        billType: 1,
        billMonth: undefined,
        billMonthFormat: undefined,
        waterFee: undefined,
        waterImage: undefined,
        electricFee: undefined,
        electricImage: undefined,
        gasFee: undefined,
        gasImage: undefined,
        rentFee: undefined,
        rentImage: undefined,
        propertyFeePerMonth: undefined,
        propertyMonths: 1,
        totalFee: undefined,
        remark: undefined
      },
      rules: {
        communityId: [{ required: true, message: this.$t('通用.文本.不能为空'), trigger: 'change' }],
        roomId: [{ required: true, message: this.$t('通用.文本.不能为空'), trigger: 'change' }],
        billType: [{ required: true, message: this.$t('通用.文本.不能为空'), trigger: 'change' }],
        billMonthFormat: [{ required: true, message: this.$t('通用.文本.不能为空'), trigger: 'change' }],
        totalFee: [{ required: true, message: this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict']),
    // 是否是社区角色
    isCommunityRole() {
      // 只要角色列表中包含 shequ 就算社区角色
      const roles = this.$store.getters.roles || []
      return roles.includes('shequ')
    }
  },
  methods: {
    hasRole(role) {
      return auth.hasRole(role)
    },
    handleAdd(communityId) {
      this.title = this.$t('通用.文本.新增')
      this.formType = 1
      this.reset()
      // 如果是社区角色，自动设置社区ID
      if (this.isCommunityRole && communityId) {
        this.currentCommunityId = communityId
        this.form.communityId = communityId
        this.getUserCommunityList(communityId)
      } else {
        this.getCommunityList()
      }
      this.open = true
    },
    handleUpdate(row, communityId) {
      this.title = this.$t('通用.文本.修改')
      this.formType = 2
      this.reset()
      // 如果是社区角色，自动设置社区ID
      if (this.isCommunityRole && communityId) {
        this.currentCommunityId = communityId
      }
      if (!this.isCommunityRole) {
        this.getCommunityList()
      }
      getBill({ billId: row.id }).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          communityId: data.communityId,
          roomId: data.roomId,
          billType: data.billType,
          billMonth: data.billMonth,
          billMonthFormat: data.billMonth,
          waterFee: data.waterFee,
          waterImage: data.waterImage,
          electricFee: data.electricFee,
          electricImage: data.electricImage,
          gasFee: data.gasFee,
          gasImage: data.gasImage,
          rentFee: data.rentFee,
          rentImage: data.rentImage,
          propertyFeePerMonth: data.propertyFeePerMonth,
          propertyMonths: data.propertyMonths,
          totalFee: data.totalFee,
          remark: data.remark
        }
        // 获取房间列表
        this.getUserCommunityList(data.communityId)
        // 编辑水电燃气费时重新计算总金额
        if (data.billType === 1) {
          this.calculateUtilityFee()
        }
        this.open = true
      })
    },
    reset() {
      this.form = {
        id: null,
        communityId: undefined,
        roomId: undefined,
        billType: 1,
        billMonth: undefined,
        billMonthFormat: undefined,
        waterFee: undefined,
        waterImage: undefined,
        electricFee: undefined,
        electricImage: undefined,
        gasFee: undefined,
        gasImage: undefined,
        rentFee: undefined,
        rentImage: undefined,
        propertyFeePerMonth: undefined,
        propertyMonths: 1,
        totalFee: undefined,
        remark: undefined
      }
      this.userCommunityList = []
      this.allRoomList = []
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    cancel() {
      this.open = false
      this.reset()
    },
    getCommunityList() {
      return listWorker({ workerType: 1, auditStatus: 1 }).then(response => {
        this.communityList = response.data || []
      })
    },
    getUserCommunityList(communityId) {
      getUserCommunityList(communityId).then(response => {
        this.userCommunityList = response.data || []
        // 拍平房间列表
        this.allRoomList = []
        this.userCommunityList.forEach(user => {
          if (user.roomList && user.roomList.length > 0) {
            user.roomList.forEach(room => {
              this.allRoomList.push({
                id: room.id,
                ownerName: user.ownerName,
                roomNumber: room.roomNumber
              })
            })
          }
        })
      })
    },
    onCommunityChange(communityId) {
      this.form.roomId = undefined
      this.userCommunityList = []
      this.allRoomList = []
      if (communityId) {
        this.getUserCommunityList(communityId)
      }
    },
    onBillTypeChange() {
      // 切换账单类型时重置费用
      this.form.waterFee = undefined
      this.form.waterImage = undefined
      this.form.electricFee = undefined
      this.form.electricImage = undefined
      this.form.gasFee = undefined
      this.form.gasImage = undefined
      this.form.rentFee = undefined
      this.form.rentImage = undefined
      this.form.propertyFeePerMonth = undefined
      this.form.propertyMonths = 1
      this.form.totalFee = undefined
    },
    calculatePropertyFee() {
      if (this.form.propertyFeePerMonth && this.form.propertyMonths) {
        this.form.totalFee = (this.form.propertyFeePerMonth * this.form.propertyMonths).toFixed(2)
      }
    },
    calculateUtilityFee() {
      const water = Number(this.form.waterFee) || 0
      const electric = Number(this.form.electricFee) || 0
      const gas = Number(this.form.gasFee) || 0
      const rent = Number(this.form.rentFee) || 0
      this.form.totalFee = Number((water + electric + gas + rent).toFixed(2))
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const data = { ...this.form }
          if (data.billMonthFormat) {
            data.billMonth = data.billMonthFormat
          }
          if (this.form.id) {
            updateBill(data).then(() => {
              this.$message.success(this.$t('通用.文本.修改成功'))
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBill(data).then(() => {
              this.$message.success(this.$t('通用.文本.新增成功'))
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

/* 账单类型选中态更明显 */
::v-deep .ant-radio-button-wrapper-checked {
  font-weight: 600;
  color: #fff !important;
  background-color: #1890ff !important;
  border-color: #1890ff !important;
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.45);
}
::v-deep .ant-radio-button-wrapper-checked::before {
  background-color: #1890ff !important;
}
</style>
